var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMySkills1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 811,
    height: 640,
    viewBox: "0 0 811 640",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M545.084 572.668C519.938 597.506 485.382 612.839 447.246 612.839C370.35 612.839 308.014 550.502 308.014 473.607C308.014 396.711 370.35 334.375 447.246 334.375C485.382 334.375 519.938 349.708 545.084 374.545C570.23 349.708 604.786 334.375 642.923 334.375C719.818 334.375 782.155 396.711 782.155 473.607C782.155 550.502 719.818 612.839 642.923 612.839C604.786 612.839 570.23 597.506 545.084 572.668Z",
    fill: "#8BB2E9",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.052,
    y: 31.6892,
    width: 417.349,
    height: 417.349,
    fill: "#FBD0B3",
    style: {
      mixBlendMode: "color-burn"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.41602,
    y: 0.510498,
    width: 31.3325,
    height: 31.3325,
    fill: "#FAD243"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 449.324,
    y: 0.522949,
    width: 31.3325,
    height: 31.3325,
    fill: "#FAD243"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 450.334,
    y: 448.523,
    width: 31.3325,
    height: 31.3325,
    fill: "#FAD243"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.33374,
    y: 448.523,
    width: 31.3325,
    height: 31.3325,
    fill: "#FAD243"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 361.775,
    y: 121.04,
    width: 417.424,
    height: 195.142,
    fill: "#E48A6F",
    style: {
      mixBlendMode: "color-burn"
    }
  }), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 331.139,
    y: 89.8608,
    width: 31.3325,
    height: 31.3325,
    fill: "#B9A8C0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 779.048,
    y: 89.8733,
    width: 31.3325,
    height: 31.3325,
    fill: "#B9A8C0"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 779.057,
    y: 315.873,
    width: 31.3325,
    height: 31.3325,
    fill: "#B9A8C0"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 330.057,
    y: 314.873,
    width: 31.3325,
    height: 31.3325,
    fill: "#B9A8C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMySkills1);
export default __webpack_public_path__ + "static/media/my-skills-1.308764017806064fdfb842dacd573265.svg";
export { ForwardRef as ReactComponent };